import React from 'react';
import { noop } from 'lodash';
import { connect } from 'react-redux';
import { State } from 'store/state';
import withEvents from 'analytics/withEvents';
import { LinksSection, SectionToLinks } from './types';
import { LinksSectionWrapper } from './styled';
import { MenuLink } from './MenuLink';
import { staticLinksSelector } from 'components/navigation/more-actions-menu/staticLinks';
import { insideReactNative } from 'react-native/lib/platform';
import { Route } from 'config/routes';

interface StaticLinksSectionsProps {
  onMadadLinkClick?: () => void;
  onClose: () => void;
  sections: SectionToLinks;
}

const StaticLinksSectionsBase: React.FC<StaticLinksSectionsProps> = ({ onMadadLinkClick, onClose, sections }) => {
  const staticLinksSections: LinksSection[] = [
    LinksSection.ManageBulletin,
    LinksSection.Tools,
    LinksSection.Guides,
    LinksSection.Localize,
  ];

  const isInsideRN = insideReactNative();

  return (
    <>
      {staticLinksSections.map(section => (
        <LinksSectionWrapper key={section}>
          {sections[section].map(link => (link.hideInApp && isInsideRN) ? null : (
            <MenuLink
              onClick={link.routeName === Route.MadadPage ? onMadadLinkClick : link.routeName === Route.UploadBulletin ? onClose : noop}
              target={link.routeName === Route.UploadBulletin ? '_self' : '_blank'}
              routeName={link.routeName}
              routeParams={link.routeParams}
              externalPath={link.externalPath}
              externalParams={link.externalParams}
              key={link.label}
              href={link.path}
              rel={link.rel}
            >
              {link.label}
            </MenuLink>
          ))}
        </LinksSectionWrapper>
      ))}
    </>
  );
};

const mapStateToProps = (state: State) => ({
  sections: staticLinksSelector(state),
});

const StaticLinksSectionsWithEvents = withEvents<StaticLinksSectionsProps>((sendEvent) => ({
  onMadadLinkClick() {
    sendEvent('madad_click', 'madad');
  },
}))(StaticLinksSectionsBase);

export const StaticLinksSections = connect(mapStateToProps)(StaticLinksSectionsWithEvents);
